export default __webpack_public_path__ + "static/bg-33dcb0c29ff4847f0bbb1cd4eafe7b70.jpg";